// Cómo llegó el comprador a un evento: el canal del link (?ref=), los UTM de
// los anuncios y el fbclid de Meta. Se guarda en el navegador 30 días por
// evento porque puede loguearse o volver otro día antes de comprar.

export const DIAS_VIGENCIA = 30;
const MS_DIA = 24 * 60 * 60 * 1000;
const CAMPOS_UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const MAX_LARGO = { fbclid: 500 };

const clave = (idevento) => `atribucion_${idevento}`;
const claveVisita = (idevento) => `visita_canal_${idevento}`;

const limpiar = (valor, campo) => (valor || "").trim().slice(0, MAX_LARGO[campo] || 100);

const leerJSON = (storage, k) => {
  try {
    return JSON.parse(storage.getItem(k));
  } catch {
    return null;
  }
};

const escribir = (storage, k, valor) => {
  try {
    storage.setItem(k, JSON.stringify(valor));
  } catch {
    // modo privado o sin espacio: la compra sigue sin atribución
  }
};

// deLaURL saca de la query lo que sirve para atribuir; null si no trae nada
export const deLaURL = (search) => {
  const params = new URLSearchParams(search || "");
  const datos = {};
  ["ref", ...CAMPOS_UTM, "fbclid"].forEach((campo) => {
    const valor = limpiar(params.get(campo), campo);
    if (valor) datos[campo] = valor;
  });
  return Object.keys(datos).length > 0 ? datos : null;
};

// combinar: gana el último clic. Un link de canal nuevo pisa al anterior, y
// un anuncio nuevo (UTM o fbclid) reemplaza los UTM de antes y, si no trae
// ref, también el canal: la venta es del anuncio.
export const combinar = (anterior, nuevo) => {
  const resultado = { ...(anterior || {}) };
  if (nuevo.ref) resultado.ref = nuevo.ref;
  if (CAMPOS_UTM.some((c) => nuevo[c]) || nuevo.fbclid) {
    if (!nuevo.ref) delete resultado.ref;
    CAMPOS_UTM.forEach((c) => delete resultado[c]);
    delete resultado.fbclid;
    CAMPOS_UTM.forEach((c) => nuevo[c] && (resultado[c] = nuevo[c]));
    if (nuevo.fbclid) resultado.fbclid = nuevo.fbclid;
  }
  return resultado;
};

const vigente = (guardado, ahora) => guardado && ahora - (guardado.guardado || 0) < DIAS_VIGENCIA * MS_DIA;

// leer: lo guardado para el evento si no venció
export const leer = (idevento, { storage = window.localStorage, ahora = Date.now() } = {}) => {
  const guardado = leerJSON(storage, clave(idevento));
  if (!vigente(guardado, ahora)) return null;
  const { guardado: _, ...datos } = guardado;
  return datos;
};

// capturar guarda lo que trae la URL y devuelve el ref si hay que contar la
// visita (una vez por día y canal en este navegador)
export const capturar = (idevento, search, { storage = window.localStorage, ahora = Date.now() } = {}) => {
  const nuevo = deLaURL(search);
  if (!nuevo) return null;
  const actual = leer(idevento, { storage, ahora });
  escribir(storage, clave(idevento), { ...combinar(actual, nuevo), guardado: ahora });

  if (!nuevo.ref) return null;
  const hoy = new Date(ahora).toISOString().slice(0, 10);
  const visita = leerJSON(storage, claveVisita(idevento));
  if (visita && visita.ref === nuevo.ref && visita.dia === hoy) return null;
  escribir(storage, claveVisita(idevento), { ref: nuevo.ref, dia: hoy });
  return nuevo.ref;
};

// paraCarrito: lo que viaja al crear el carrito, con el código escrito
export const paraCarrito = (idevento, codigo, opciones) => {
  const datos = { ...(leer(idevento, opciones) || {}) };
  const escrito = (codigo || "").trim();
  if (escrito) datos.codigo = escrito.slice(0, 40);
  return Object.keys(datos).length > 0 ? datos : null;
};

// normalizarCodigo: igual que el backend (controllers/canales): mayúsculas,
// sin acentos ni espacios, sólo letras, números, guion y guion bajo
export const normalizarCodigo = (texto) =>
  (texto || "")
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Z0-9_-]/g, "")
    .slice(0, 40);

export const linkDeCanal = (origen, rutaEvento, codigo) => `${origen}${rutaEvento}?ref=${encodeURIComponent(codigo)}`;
